module.exports = __webpack_public_path__ + "static/media/Velka-bites.a00e1e5b.jpg";